import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// redux
import { refreshUser } from 'redux/auth/operations';
import { getUsers } from 'redux/users/operations';
import { getCities } from 'redux/locations/operations';
import { getPassengers } from 'redux/passengers/operations';
// hooks
import { useAuth, useWindowDimensions } from 'hooks';
// components
import Loader from 'components/Loader/Loader';
import UsersList from 'components/UsersList/UsersList';
import NewUsersList from 'components/UsersList/NewUsersList';
import { PrivateRoutesOutlet, RestrictedRoutesOutlet } from 'components/Routes';
// pages
import AuthPage from 'pages/AuthPage/AuthPage';
import UsersPage from 'pages/UsersPage/UsersPage';
import PassengersPage from 'pages/PassengersPage/PassengersPage';
import TicketsPage from 'pages/TicketsPage/TicketsPage';
import PassengersPageForPrint from 'pages/PassengersPage/PassengersPageForPrint';
import RecoveryPage from 'pages/RecoveryPage/RecoveryPage';
import ResetPasswordPage from 'pages/ResetPasswordPage/ResetPasswordPage';
// pages lazy
// const UsersPage = lazy(() => import('pages/UsersPage/UsersPage'));

const App = () => {
  const [render, setRender] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const { height } = useWindowDimensions();
  const { isRefreshing, isLoggedIn, isSuperAdmin } = useAuth();

  useEffect(() => {
    if (render) return setRender(false);
    dispatch(refreshUser());
  }, [render, dispatch]);

  useEffect(() => {
    if (render) return;
    if (!isLoggedIn) return;
    dispatch(getCities());
    dispatch(getPassengers({}));
  }, [render, dispatch, isLoggedIn]);

  useEffect(() => {
    if (render) return;
    if (!isSuperAdmin) return;
    dispatch(getUsers({ new: true }));
  }, [render, dispatch, isSuperAdmin]);

  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, [location]);
  useEffect(() => { document.querySelector('html').style.setProperty('--window-height', `${height}px`); }, [height]);

  return isRefreshing ? (
    <Loader />
  ) : (
    <Routes>
      <Route element={<RestrictedRoutesOutlet redirectTo="/" />}>
        <Route path="/login" element={<AuthPage page={'login'} />} />
        <Route path="/signup" element={<AuthPage page={'signup'} />} />
        <Route path="/recovery" element={<RecoveryPage />} />
        <Route path="/reset/:resetToken" element={<ResetPasswordPage />} />
      </Route>

      <Route path="/" element={<PrivateRoutesOutlet redirectTo="/login" />}>
        <Route index element={<PassengersPage />} />
        <Route path="users" element={<UsersPage />}>
          <Route index element={<UsersList />} />
          <Route path="new" element={<NewUsersList />} />
        </Route>
        <Route path="tickets" element={<TicketsPage />} />
        <Route path="passengers-for-print" element={<PassengersPageForPrint />} />
      </Route>
    </Routes>
  );
};

export default App;
